<template>
  <card class="pt-3" bodyClasses="px-2 px-lg-3 pt-0">
    <div class="d-flex justify-content-between flex-column flex-lg-row align-items-start">
      <div v-if="for_user" class="mb-2 d-flex align-items-start flex-column">
        <p v-if="for_user.email" class="mb-1 text-secondary mr-3 text-size-small">
          <i class="fas fa-envelope"></i> <Email v-model="for_user.email" />
        </p>
        <p v-if="for_user.phone_number" class="text-secondary text-size-small mb-0">
          <i class="fas fa-phone-alt"></i> <Phone v-model="for_user.phone_number" />
        </p>
      </div>
      <p class="mb-1 text-size-small text-right">
        <span class="mr-3">{{userName || ''}} </span>
        <span v-if="$page.props.user.account_balance" class>
          <strong>Total Balance: ${{formatCurrency(this.$page.props.user.account_balance)}}</strong>
        </span>
      </p>
    </div>
    <template v-if="outstandingCharges.length">
      <div :class="getProgressClass(charge)" v-for="charge in outstandingCharges" :key="charge.id" class="d-flex py-2 payment-item">
        <div v-if="getProgressClass(charge)" class="progress-bar-container">
          <div :style="getProgress(charge)" class="item-progress-bar">
            <PaymentPart :charge="charge" />
            <div @mouseenter="charge.hovered = true" @mouseleave="charge.hovered = false" 
            :class="{hovered:charge.hovered}" class="progress-indicator">
              <p v-if="charge.hovered" :class="{hovered:charge.hovered}" class="m-0 val1">{{moment(charge.transaction_date).format('MM/D/YY')}}</p>
              <p v-if="charge.hovered" :class="{hovered:charge.hovered}" class="m-0 val2">${{formatCurrency(-charge.appliedPaymentsTotal)}}</p>
            </div>
          </div>
          <RemainingAmount @remainingClicked="remainingClicked" :charge="charge" :user="user" />
        </div>
        <div class="col-6 item-col product text-size-small lh-small">
          <p v-if="!charge.order" class="m-0">Starting Account Balance</p>
          <p class="m-0" :title="charge.product.name" v-else-if="charge.product"><span class="product-sku">{{charge.product.sku}}</span> - {{charge.product.name}}</p>
          <p v-else class="m-0">Shipping/Tax</p>
        </div>
        <div class="col-3 item-col text-size-small lh-small">
          <p class="m-0 d-flex">
            <span class="mr-2" v-if="charge.orderItem"><strong>x</strong>{{charge.orderItem.qty}}</span>
            <span class="price">${{formatCurrency(charge.amount) || '0'}}</span>
          </p>
        </div>
        <div class="col-3 item-col text-size-small lh-small" v-if="charge.order">
          <inertia-link class="order-link m-0" :href="route('order.view', charge.order.id)">#{{charge.order.id}}</inertia-link>
        </div>
      </div>
    </template>
    
    <template v-if="paidCharges.length">
      <div v-for="(charge, index) in paidCharges" :key="charge.id" class="d-flex py-2 payment-item">
        <div v-if="index === 0" class="flex-center paid-off-container">
          <p class="paid-off-text m-0">Paid Off</p>
        </div>
        <div class="progress-bar-container">
          <div class="item-progress-bar w-100">
            <PaymentPart :charge="charge" />
          </div>
        </div>
        <div class="col-6 item-col product text-size-small lh-small">
          <p class="m-0">
            <span v-if="charge.product">{{charge.product.name}}</span>
            <span v-else>Shipping/Tax</span>
          </p>
        </div>
        <div class="col-3 item-col text-size-small lh-small">
          <p class="m-0 d-flex">
            <span class="mr-2" v-if="charge.orderItem"><strong>x</strong>{{charge.orderItem.qty}}</span>
            <span class="mr-2 price">${{formatCurrency(charge.amount) || '0'}}</span>
          </p>
        </div>
        <div class="col-3 item-col text-size-small lh-small" v-if="charge.order">
          <inertia-link class="order-link m-0 text-white" :href="route('order.view', charge.order.id)">#{{charge.order.id}}</inertia-link>
        </div>
      </div>
    </template>
  </card>
</template>

<script>
  import moment from 'moment'
  import PaymentPart from '@/Components/Payment/PaymentPart'
  import RemainingAmount from '@/Components/Payment/RemainingAmount'

  export default {
    components: {
      PaymentPart,
      RemainingAmount,
    },
    data() {
      return {
        outstandingCharges: [],
        paidCharges: []
      }
    },
    props: {
      charges: Array,
      classes: String,
      user: Object,
      for_user: Object
    },
    computed: {
      userName() {
        if (this.$page.props.auth.user.role == 'mtd') {
          if (!this.$page.props.for_user.first_name) return false
          return this.$page.props.for_user.first_name + ' ' + this.$page.props.for_user.last_name          
        } else {
          if (!this.$page.props.auth.user.first_name) return false
          return this.$page.props.auth.user.first_name + ' ' + this.$page.props.auth.user.last_name
        }
      }
    },
    mounted() {
      this.outstandingCharges = this.charges.filter(elem => { return elem.balance > 0 })
      this.paidCharges = this.charges.filter(elem => { return elem.balance == 0 })

      this.outstandingCharges.forEach(elem => { elem.hovered = false })
    },
    created() {
      this.moment = moment
    },
    methods: {
      getProgress(charge) {
        const percentage = Math.round((-charge.appliedPaymentsTotal / charge.amount)*100)
        return `width: ${percentage}%;`
      },
      remainingClicked(remaining) {
        this.$emit('updateAmount', remaining)
      },
      getProgressClass(charge) {
        if (charge.appliedPaymentsTotal == 0) return false
        else if (charge.balance <= 0) return 'paid-off'
        else return 'paid-progress'
      },
    }
  }
</script>
